import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import styles from './Tooltip.module.less';
import clsx from 'clsx';
import useLocalStorage from '../../hooks/useLocalStorage';

const Tooltip = ({ text, localStorageKey, hideAfterInMilliseconds, style }) => {
  const [localStorageValue, setLocalStorageValue] = useLocalStorage(
    localStorageKey,
    false
  );
  const [show, setShow] = useState(false);

  const hide = () => {
    setLocalStorageValue(true); //true means we've shown it already
    setShow(false);
  };

  useEffect(() => {
    // localStorageValue is null at first time
    // real value at second time, when updated via useLocalStorage's useEffect
    if (localStorageValue === false) {
      setShow(true);

      const timerId = setTimeout(() => {
        hide();
      }, hideAfterInMilliseconds);

      return () => window.clearTimeout(timerId);
    }
  }, [localStorageValue]);

  return !show ? null : (
    <div className={clsx(styles.container, style.container)}>
      <div className={clsx(styles.box, style.box)}>
        <span className={clsx(styles.triangle, style.triangle)} />
        <Icon
          name="cancel-light"
          className={styles.closeIcon}
          onKeyDown={hide}
          onPointerDown={hide}
          title="Close"
          role="button"
          tabIndex="0"
        />
        {text}
      </div>
    </div>
  );
};

Tooltip.propTypes = {
  text: PropTypes.string.isRequired,
  localStorageKey: PropTypes.string.isRequired,
  hideAfterInMilliseconds: PropTypes.number.isRequired,
  style: PropTypes.objectOf(
    PropTypes.shape({
      container: PropTypes.string,
      box: PropTypes.string,
      triangle: PropTypes.string,
    })
  ),
};

export default Tooltip;
